import React, { useEffect, useState } from "react";
import { BiUpload } from "react-icons/bi";

const FilePickerField = ({
    preloadedFile,
    onFileSelect,
    label = "Select Image",
    placeHolder = "Select Image",
    acceptedFormats = ".jpg,.png,.jpeg,.mp4,.mkv,.gif,.mov,.pdf",
    maxFileSize = 10,
    disabled = false,
}) => {
    const [selectedFile, setSelectedFile] = useState(preloadedFile || null);

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file.name); // Set the file name
            onFileSelect(file); // Send the selected file to the parent component
        }
    };

    useEffect(() => {
        setSelectedFile(preloadedFile);
    }, []);
    return (
        <div className="w-full">
            <label className="block font-semibold text-gray-700 mb-2">{label}</label>
            <div className="border border-gray-300 rounded-lg p-2 flex items-center justify-between bg-white shadow-sm hover:shadow-md transition-shadow cursor-pointer relative">
                <div className="flex items-center gap-2 truncate">
                    <BiUpload className="h-5 w-5 text-gray-500" />
                    <p className="text-xs text-gray-700">
                        {selectedFile ? selectedFile : `${placeHolder} (Up to ${maxFileSize}MB)`}
                    </p>
                </div>
                <input
                    type="file"
                    className="absolute inset-0 opacity-0 cursor-pointer text-xs"
                    accept={acceptedFormats}
                    onChange={handleFileSelect}
                    disabled={disabled}
                />
            </div>
        </div>
    );
};

export default FilePickerField;
